import React from "react"
import { ReactComponent as PlusSVG } from "lib/assets/plus.svg"
import { ReactComponent as MinusSVG } from "lib/assets/minus.svg"
import { ReactComponent as MenuSVG } from "lib/assets/menu.svg"
import { ReactComponent as NewBet } from "lib/assets/arrow-left.svg"
import { ReactComponent as ClearSVG } from "lib/assets/clear.svg"
import { colors } from "lib/colors"

export const GAME_DESCRIPTION = {
  title: "Baccarat",
  description: [
    `     Baccarat is yet another revolutionary concept of simplicity developed by Orbital’s talented team.`,
    `Make Strategic decisions based on the card combinations and bet on either Player hand, banker or the tie!`,
    `The highest score in this game is 9 (natural). Whichever hand is closer to this number Wins!`,
    `Cards from 2 to 9 have their direct value. 10, J, Q, K have a value of 0 and the Ace has a value of 1.
    The value of each hand depends on the sum of the cards (points).`,
    `If the sum of the cards is a two-digit number for example 13, then the left number disappears and the hand value becomes 3.`,
    `If 20 is the sum the hand value becomes 0 and so on.`,
    `There are a maximum of 3 cards with the minimum of 2, if they add up to 5 or more.`,
    `If the result is a tie and no one bets on Tie, bets on the banker or player are returned`,
  ],
}
export const Settings = [
  {
    icon: <MenuSVG className='menu' />,
    title: "Settings Button",
    description: "Press the button to access Settings",
    background: colors.primary,
    color: colors.tertiaryDark,
  },
  {
    title: "Provably Fair",
    description:
      "This section grants you the possibility of checking the fairness of the game for yourself",
  },
  {
    title: "Game Rules",
    description: "Short Description of the Game",
  },
  {
    title: "History",
    description:
      "Shows your previous plays and allows you to devise new tactics for your next shuffle",
  },
  {
    title: "Bet Reply",
    description: "Click on any bet in history page to see your bet reply",
  },
  {
    title: "Music Button",
    description: "Turn on the unique audio overlay of the game",
  },
  {
    title: "Sound Button",
    description: "Enable unique action sounds of the game",
  },
  {
    title: "Volume",
    description: "Set the volume",
  },
]

export const GameplayCustomization = [
  {
    title: "Clear Button",
    description: "Clears all selected bets",
    icon: <ClearSVG />,
    background: colors.secondary,
    color: colors.tertiaryDark,
  },
  {
    title: "Play Button",
    description: "start the game",
    icon: "PLAY",
    background: colors.secondary,
    textColor: colors.secondaryBackground,
    width: "100px",
    size: "14px",
  },
  {
    title: "Rebet Button",
    description: "Repeat the Same Bet",
    icon: "REBET",
    background: colors.secondary,
    textColor: colors.secondaryBackground,
    width: "100px",
    size: "14px",
  },
  {
    title: "New Bets Button",
    description: "Make a new Bet",
    icon: <NewBet />,
    background: colors.secondary,
    color: colors.tertiaryDark,
  },
  {
    title: "1/2 Button",
    description: "Divides your bet by half",
    icon: "1/2",
    background: colors.secondary,
    textColor: colors.secondaryBackground,
  },
  {
    title: "2X Button",
    description: "Doubles your bet instantly",
    icon: "2X",
    background: colors.secondary,
    textColor: colors.secondaryBackground,
  },
  {
    title: "Click on Bet Amount",
    description: "Additional Betting Options",
  },
  {
    title: "1/2 Button",
    description: "Divides your bet by half",
    icon: "1/2",
    background: colors.secondary,
    textColor: colors.secondaryBackground,
  },
  {
    title: "2X Button",
    description: "Doubles your bet instantly",
    icon: "2X",
    background: colors.secondary,
    textColor: colors.secondaryBackground,
  },
  {
    title: "5X Button",
    description: "Multiply your bet by 5",
    icon: "5X",
    background: colors.secondary,
    textColor: colors.secondaryBackground,
  },
  {
    title: "+ Button",
    description: "Increase amount by single unit",
    icon: <PlusSVG />,
    background: colors.secondary,
    textColor: colors.secondaryBackground,
  },
  {
    title: "- Button",
    description: "Decrease amount by single unit",
    icon: <MinusSVG />,
    background: colors.secondary,
    textColor: colors.secondaryBackground,
  },
]
